export const isEmptyObject = (obj) => {
    const keys = Object.keys(obj);
    return (obj &&
        ((keys.length === 0 && Object.getPrototypeOf(obj) === Object.prototype) ||
            keys.filter((x) => obj[x] !== undefined).length === 0));
};
